import {useMediaQuery} from "react-responsive";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {Ajax} from "../Service/ajax";
import DOMPurify from 'dompurify';
import {hosts} from "../env/Environment";

export default function HomeSection({title, description, cmpParam, page=false}) {
    const isSmallScreen = useMediaQuery({ maxWidth: 575 });
    const navigate = useNavigate();
    const [uri, setUri] = useState( `${hosts.api}/exposed/v1/mda/images/show?target=logo&target_id=${cmpParam}`);
    function SafeDescription({ description }) {
        const hasHTMLTags = /<\/?[a-z][\s\S]*>/i.test(description);

        if (hasHTMLTags) {
            const cleanDescription = DOMPurify.sanitize(description);
            return (
                <div
                    className="mt-1 mb-1 fs-large w-100"
                    dangerouslySetInnerHTML={{ __html: cleanDescription }}
                />
            );
        }

        return (
            <div className="mt-1 mb-1 fs-large w-100">
                {description}
            </div>
        );
    }

    const urlSearchParams = new URLSearchParams(window.location.search);
    return (
        <section className="py-0" id="home">
            <div className="container position-relative">
                <div className="row align-items-center py-8">
                    <div className={`col-md-8 col-lg-7 mb-4 mt-4 ${!isSmallScreen ? 'order-0' : 'order-1'}`}>
                        <div className="text-center text-md-start w-100">
                            <h1 className="mb-1 display-4 fw-bold lh-sm">{title}</h1>
                            {SafeDescription({ description })}
                            {page? "" :
                                <button type={"button"} className={"btn btn-outline-netikash"}
                                        onClick={() => navigate("/login?target=login")}> Commencer maintenant<i
                                    className={"bx bx-chevrons-right"}></i></button>}
                        </div>
                    </div>
                    <div className="col-md-4 col-lg-5 mb-4 mt-4">
                        <div className="text-center text-md-end">
                            {page ?
                                <img
                                    className="img-fluid"
                                    src={uri}
                                    width="350"
                                    alt=""
                                />
                                :
                                <img
                                    className="img-fluid"
                                    src={require("../assets/img/illustrations/Netikash subscribe.png")}
                                    width="350"
                                    alt=""
                                />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
}